import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {JobsDataService} from '../../../../modules/jobs/jobs-data.service';
import {UserDataService} from '../../../../modules/auth/user-data.service';
import {NgForm} from '@angular/forms';
import { CandidateDataService } from '../../candidate-account/candidate-data.service';

@Component({
    selector: 'app-job-applications',
    templateUrl: './job-applications.component.html',
    styleUrls: ['./job-applications.component.scss']
})

export class JobApplicationsComponent implements OnInit {
    jobId: string;
    applications: any = [];
    interviews: any = [];
    jobAppLoaded = false;
    previewApplication: any;
    job: object =[];
    fieldType= 'candidateScore';
    dir= 'desc';
    userData:any;

    showAllInterviews = false;
    showAllApps = true;

    constructor(private route: ActivatedRoute, private jobsDataService: JobsDataService, private candidateDataService: CandidateDataService , private router: Router) {
    }

    ngOnInit() {
        this.route.params.subscribe((params: Params) => {
            this.jobId = params['id'];
        })

        this.jobsDataService.getCurrentJob(this.jobId).subscribe(job => {
            if(job !== null ){
                this.job = job;
                console.log(this.job);
            }else{
                this.router.navigate(['/404']);
            }

        })

        this.getJobApplications('candidateScore', 'desc');
    }

    getJobApplications(fieldName, dir) {
        this.jobsDataService.getJobApplications(this.jobId, fieldName, dir).subscribe(res => {
            this.applications = res['content'];
            this.jobAppLoaded = true;

            this.setCurrentApplication(0);

            this.applications.forEach(singleApplication => {
                if (singleApplication.statusApplication.hasInterviewDate) {
                    this.interviews.push(singleApplication);
                }

                this.candidateDataService.getCandidateProfileData(singleApplication.userId).subscribe(user=>{
                    console.log('user',user);
                    this.userData=user;
                })
            })
        })
    }

    setCurrentApplication(i: number) {
        this.previewApplication = this.applications[i];
        console.log(this.applications[i]);
    }

    displayApps(arg) {
        if (arg === 'all') {
            this.showAllInterviews = false;
            this.showAllApps = true;
        } else {
            this.showAllInterviews = true;
            this.showAllApps = false;
        }
    }


    onSorting() {
        this.getJobApplications(this.fieldType, this.dir);
    }
}
